export default "__VITE_ASSET__3yX375IV__"